import Vue from 'vue';
import Vuex from 'vuex';
import Login from './modules/login';
import poll from './modules/poll';
import Membership from './modules/membership';
import CustomBranding from './modules/customBranding';

Vue.use(Vuex);
import { HTTP } from '@/shared/http';


const PREMIUM = 1;
const BETA = 2;
const ADMIN = 256;


export default new Vuex.Store({
  modules: {
    Login,
    poll,
    Membership,
    CustomBranding,
  },

  state: {
    info: null,
    visibleNav: true,
    details: null,
    options: null,
    isAdminLink: false,
    isPublicLink: false,
    keyUserId: null, // not sure if this is related to invitations
    invitationId: null, // contains the key of the invitation link which is the invitation id
    mobileView: true,
    mobileDevice: null,
    type: 2,

    // used for "laoding" status of a specific choice
    loadingId: null,
    loadingParticipant: null,

    // invitations: [],
    // participants: [],
    token: localStorage.getItem('token') || '',
    curInvitation: null,
    apiUrlSegment: process.env.VUE_APP_API_URI_SEGMENT,
    csrfInitialized: false,
    subAdminDetails: null,
    isNewPoll: false
  },

  mutations: {
    setDetails(state, details) {
      state.details = details;
    },

    setLoadingId(state, loadingId) {
      state.loadingId = loadingId;
      console.log('Update stateLoadingId:', loadingId);
    },

    setLoading(state, { loadingId, loadingParticipant }) {
      console.log('Update stateLoading:', loadingId, loadingParticipant);
      state.loadingId = loadingId;
      state.loadingParticipant = loadingParticipant;
    },

    setMobileView(state, value) {
      state.mobileView = value;
    },

    setMobileDevice(state, value) {
      state.mobileDevice = value;
    },

    setCsrfInitialized(state) {
      state.csrfInitialized = true;
    },

    // updateDetails(state, details) {
    //   state.details = details;

    //   console.log('Update backend with new details:', details);
    //   if (details.ownerUser) {
    //     if (
    //       state.poll.poll.participants &&
    //       state.poll.poll.participants.length > 0
    //     ) {
    //       state.poll.poll.participants[0].name = details.ownerUser.name;
    //     }
    //     state.poll.poll.user.name = details.ownerUser.name;
    //     state.poll.User_name = details.ownerUser.name;
    //     console.log('update the user participant:', state.poll);
    //   }
    //   return HTTP.post(
    //     `${process.env.VUE_APP_API_URI_SEGMENT}/poll/details/${state.poll.poll.id}`,
    //     {
    //       title: details.title,
    //       type: details.type,
    //       description: details.description,
    //       options: details.options,
    //       ownerUser: details.ownerUser,
    //       bg_image_path: details.bg_image_path,
    //     }
    //   )
    //     .then((response) => {
    //       console.log('currect poll user:', state.poll.poll.user);
    //       console.log('response after updateDetails:', response.poll);
    //       return response;
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },
    updateDetails(state, details) {
      state.details = details;
    },

    updateOptions(state, options) {
      console.assert(options != null);
      state.options = options;
      console.error('Update backend with new options:', options);
      HTTP.post(
        `${process.env.VUE_APP_API_URI_SEGMENT}/poll/options/${state.poll.poll.id}`,
        {
          options: options,
        }
      )
        .then((response) => {
          console.log('response:%o' + response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    setKeyUserId(state, val) {
      state.keyUserId = val;
    },

    setInvitationId(state, val) {
      state.invitationId = val;
    },

    setIsAdminLink(state, val) {
      state.isAdminLink = val;
    },

    setIsPublicLink(state, val) {
      state.isPublicLink = val;
    },

    setVisibleNav(state, val) {
      state.visibleNav = val;
    },

    setInfo(state, info) {
      state.info = info;
    },

    setInvitation(state, invitation) {
      console.error('setInvitation:', invitation);
      state.curInvitation = invitation;
      console.log('curInvitation:', state.curInvitation);
    },

    setType(state, type) {
      state.type = type;
    },

    setOwner(state, owner) {
      state.owner = owner;
    },
    // --- subadmin ---
    setSubAdminDetails(state, value) {
      state.subAdminDetails = value;
    },
    setIsNewPoll(state, value) {
      state.isNewPoll = value
    }
  },

  actions: {
    initCsrf({ commit, state }) {
      if (state.csrfInitialized) return;
      return HTTP.get('/sanctum/csrf-cookie').then(() => {
        commit('setCsrfInitialized');
      });
    },

    updateDetails({ commit, state }, details) {
      commit('updateDetails', details);

      console.log('Update backend with new details:', details);
      // check if the first participant is not the owner (owner was removed) and do not update the owner name.

      if ( (state.poll.poll.participants.length === 0) || (state.poll.poll.participants[0].user_id != state.poll.poll.user.id) ) {
        details.ownerUser = null;
      }
      if (details.ownerUser) {
        if (
          state.poll.poll.participants &&
          state.poll.poll.participants.length > 0
        ) {
          console.error(
            'updteDetails:',
            state.poll.poll.participants[0].user_id,
            state.poll.poll.user.id
          );
          if (
            state.poll.poll.participants[0].user_id == state.poll.poll.user.id
          ) {
            state.poll.poll.participants[0].name = details.ownerUser.name;
          }
        }
        state.poll.poll.user.name = details.ownerUser.name;
        state.poll.User_name = details.ownerUser.name;
        console.log('update the user participant:', state.poll);
      }

      return HTTP.post(
        `${process.env.VUE_APP_API_URI_SEGMENT}/poll/details/${state.poll.poll.id}`,
        {
          title: details.title,
          type: details.type,
          description: details.description,
          options: details.options,
          ownerUser: details.ownerUser,
          bg_image_path: details.bg_image_path,
          closed: details.closed,
          deadline: details.deadline,
          design_id: details.design_id,
          delay_interval:details.delay_interval,
          delay_type:details.delay_type
        }
      )
        .then((response) => {
          console.log('updateDetails result after post:', response.data);
          return response;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // This action used to identify the poll status like new or old one, value will be True and False
    // New => True
    // Old => false
    updatePollStatus({ commit }, value) {
      commit('setIsNewPoll', value);
    }
  },

  getters: {
    getPollType(state) {
      return state.type;
    },

    getDetails(state) {
      return state.details;
    },

    getOptions(state) {
      return state.options;
    },

    isOwner(state) {
      if (state.isAdminLink) return true;
      // Mitko - this does not make sense for me
      // if (!state.Login.userId || !state.poll.poll) return false;
      //console.error('isOwner:', state.Login.userId, state.poll.poll.user_id);
      if (state.Login.userId != state.poll.poll.user_id) {
        // check for the sub-admin if found any, sub-admin will have same permission and rights
        for(let i=0; i < state.poll.poll.participants.length; i++) {
          if(state.poll.poll.participants[i].user_id == state.Login.userId) {
            if(state.poll.poll.participants[i].is_sub_admin == 1) {
              return true;
            }
            return false;
          }
        }
        return false;
      }
      return true;
    },

    getPollOwner(state) {
      return state.isAdminLink || state.Login.userId == state.poll.poll.user_id;
    },

    isAdminLink(state) {
      return state.isAdminLink;
    },

    design(state) {
      return state.poll.design;
    },

    isDarkMode(state) {
      if (state.poll.poll.options.darkMode) return true;
      return false;
    },

    userId(state) {
      // console.log(
      //   'Getters userId: - get userId with state:',
      //   state.isAdminLink
      // );
      if (state.isAdminLink) {
        // --- subadmin ---
        if(state.subAdminDetails) {
          return state.subAdminDetails.id;
        }
        // --- subadmin end ---
        const userId = state.poll.poll.user.id;
        //console.log('Getters userId: - get userId with admin link:', userId);
        return userId;
      }
      if (state.curInvitation) {
        // find the invited participant and return his userId
        const participantId = state.curInvitation.participant_id;
        const participant = state.poll.poll.participants.find(
          (p) => p.id == participantId
        );
        if( !participant) {
          return null;
        }

        if (participant.user) return participant.user.id;
      }
      //console.log('Getters userId: - return logged in userI');
      return state.Login.userId;
    },

    userName(state) {
      if (state.isAdminLink && !state.Login.authenticated) {
        return state.poll.poll.user.name;
      }
      return state.Login.user ? state.Login.user.name : null;
    },

    user(state) {
      if (state.isAdminLink || state.keyUserId) {
        return state.poll.poll.user;
      }
      return state.Login.user;
    },

    userLocale(state) {
      if (state.isAdminLink && !state.Login.authenticated) {
        return state.poll.poll.user.locale;
      }
      return state.Login.user ? state.Login.user.locale : null;
    },

    ownerId(state) {
      return state.poll.poll ? state.poll.poll.user_id : null;
    },

    getInfo(state) {
      return state.info;
    },

    isPublicLink(state) {
      return state.isPublicLink;
    },

    isAdmin(state) {
      if (!state.Login.user) return false;
      return state.Login.user.roles & ADMIN;
    },

    isSuperAdmin(state) {
      if (state.Login.user) return state.Login.user.roles >= ADMIN;
      if (state.poll.poll.user) return state.poll.poll.user.roles >= ADMIN;
    },

    isPremium(state) {
      if (state.isAdminLink) {
        const user = state.poll.poll.user;
        if (state.keyUserId != user.id) return false;
        return user.roles > ADMIN || user.roles == PREMIUM;
      }
      if (!state.Login.user) return false;
      return state.Login.user.roles > ADMIN || state.Login.user.roles == PREMIUM;
    },

    isBeta(state) {
      if (!state.Login.user) return false;
      return state.Login.user.roles > ADMIN || state.Login.user.roles == BETA;
    },
    isSubAdmin(state) {
      if(state.subAdminDetails == null) {
        let participantId;
        if(state.Login.user) {
          participantId = state.Login.user.id;
        } else {
          return false;
        }
        const participant = state.poll.poll.participants.find(
          (p) => p.user_id == participantId
        );

        // check if the owner is removed from the participant list
        if( participant == null ) {
          return false;
        }
        return participant.is_sub_admin == 1;
      }
      return true;
    },
    getPollStatus(state) {
      return state.isNewPoll;
    }
  },
});
